<template>
  <v-card
    width="100%"
    class="my-2 mx-0"
    color="grey lighten-4"
    hover
  >
    <v-card-text>
      <v-container
        fluid
        class="pa-0"
      >
        <v-row
          align="center"
          class="ma-0"
        >
          <v-col
            cols="12"
            class="py-0 px-1"
          >
            <v-row
              align="center"
              class="ma-0"
            >
              <v-col
                cols="12"
                class="px-0 py-1 text-truncate"
              >
                <v-icon color="green" small>mdi-leaf</v-icon>
                <span class="body-2 font-weight-bold">{{item["nm_analysis_type"]}}</span>
              </v-col>
            </v-row>
            <v-row
              align="center"
              class="ma-0"
            >
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <span class="body-2"><b>Área: </b> {{flTotalArea | toFixedWithComma}} ha</span>
              </v-col>
              <v-col
                cols="12"
                class="px-0 py-1"
                v-if="chargeTypeIsCredits"
              >
                <span class="body-2"><b>Preço: </b> {{currencySymbol}} {{flPrice | toFixedWithComma}}</span>
                <v-tooltip
                  v-if="mustShowMinPriceTooltip"
                  top
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="warning"
                      small
                      v-on="on"
                      class="price-info__icon ma-2"
                    >
                      {{$vuetify.icons.values["mdiAlertCircle"]}}
                    </v-icon>
                  </template>
                  <span >O preço mínimo por análise é de {{currencySymbol}} {{minPrice | toFixedWithComma}}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import {isEqual, lt} from "lodash/lang"
  import {find} from "lodash/collection"

  export default {
    name: "PostProcessingRequestAnalysisCard",
    props: {
      item: {
        type: Object,
        required: true
      },
      flTotalArea: {
        type: Number,
        required: true
      },
      abCropType: {
        type: String,
        validator: prop => typeof prop === "string" || prop === null || prop === undefined,
      },
      postProcessingPrices: {
        type: Object,
        required: true,
      }
    },
    data: () => ({
      isOver: false,
    }),
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      }
    },
    computed: {
      chargeTypeIsCredits() {
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits')
          return true
        return false
      },      
      flPrice() {
        let flPriceMultiplier = 0.0
        const item = find(this.postProcessingPrices.all, priceItem => {
          return isEqual(priceItem["agronomic_analyzes"]["ab_analysis_type"], this.item["ab_analysis_type"]) &&
            isEqual(priceItem["crop_type"]["ab_crop_type"], this.abCropType)
        })
        if (item)
          flPriceMultiplier += this.$appMng.isIntl ? item["price_product"]["fl_intl_base_price"] : item["price_product"]["fl_base_price"]
        return (flPriceMultiplier * this.flTotalArea)
      },
      mustShowMinPriceTooltip() {
        return !!lt(this.flPrice, this.minPrice);
      },
      minPrice() {
        if (this.$subsMng.subscriptionPlan["ab_subscription_plan"] === "ENTERPISE_PLAN_TRIAL_TOTVS" || this.$subsMng.subscriptionPlan["ab_subscription_plan"] === "PRO_PLAN_TRIAL_TOTVS")
          return 0
        if (this.$appMng.isIntl) return 20
        return 60
      },
      currencySymbol() {
        if (this.$appMng.isIntl)
          return "$"
        return "R$"
      },
    }
  }
</script>

<style scoped lang="scss">
  .price-info__icon {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>
